import { Button } from "antd";
import style from "./BrandButton.module.css";
import { ArrowRightOutlined } from "@ant-design/icons";
import { forwardRef, useImperativeHandle } from "react";

const BrandButton = forwardRef(
  (
    {
      type = "default",
      htmlType = "button",
      onSubmit,
      loading = false,
      children,
      size = "large",
      block = false,
    },
    ref,
  ) => {
    useImperativeHandle(ref, () => ({
      triggerSubmit: onSubmit,
    }));
    const className =
      type === "solidyellow" ? style.solidyellow : style.solidblue;

    return (
      <Button
        type="primary"
        size={size}
        shape="round"
        className={className}
        htmlType={htmlType}
        onClick={onSubmit}
        icon={<ArrowRightOutlined />}
        iconPosition="end"
        loading={loading}
        block={block}
      >
        {children}
      </Button>
    );
  },
);

export default BrandButton;
